import angular from 'angular';

import { ConfiguracoesListRouting  } from './configuracoes.routes';

import { ConfiguracoesService } from './configuracoes.service';

import { ConfiguracoesIndexController } from './index/configuracoes.index.controller';

import { MeurhContribuintesIndividuaisComponent } from './components/contribuintes-individuais/contribuintes-individuais.component';
import { ConfiguracoesPortariaComponent } from './components/portaria/configuracoes-portaria.component';
import { PortariaParametrizacaoModalService } from './components/portaria/modals/parametrizacao/portaria-parametrizacao.modal.service';
import { PortariaParametrizacaoModalController } from './components/portaria/modals/parametrizacao/portaria-parametrizacao.modal.controller';

export const ConfiguracoesModule = angular.module('ConfiguracoesModule', ['ui.router.state', ])
    .controller('ConfiguracoesIndexController', ConfiguracoesIndexController)
    .controller('PortariaParametrizacaoModalController', PortariaParametrizacaoModalController)
    .service('ConfiguracoesService', ConfiguracoesService)
    .service('PortariaParametrizacaoModalService', PortariaParametrizacaoModalService)
    .component('meurhContribuintesIndividuaisComponent', MeurhContribuintesIndividuaisComponent)
    .component('configuracoesPortariaComponent', ConfiguracoesPortariaComponent)
    .config(ConfiguracoesListRouting)
    .name;
